import { RootState } from "store/store";
import { EstadoRequisicao } from "store/types";

class FormularioSelector {
  static readonly isOcioso = (it: RootState) => it.avaliacoes.formulario.estado === EstadoRequisicao.OCIOSO;
  static readonly isCarregando = (it: RootState) => it.avaliacoes.formulario.estado === EstadoRequisicao.CARREGANDO;
  static readonly erros = (it: RootState) => it.avaliacoes.formulario.erros;
}

class ListaSelector {
  static readonly isOcioso = (it: RootState) => it.avaliacoes.lista.estado === EstadoRequisicao.OCIOSO;
  static readonly isCarregando = (it: RootState) => it.avaliacoes.lista.estado === EstadoRequisicao.CARREGANDO;
  static readonly hasErros = (it: RootState) => it.avaliacoes.lista.estado === EstadoRequisicao.FALHOU;
  static readonly erros = (it: RootState) => it.avaliacoes.lista.erros;

  static readonly elementos = (it: RootState) => it.avaliacoes.lista.elementos;
}

export class AvaliacaoSelector {
  static readonly lista = ListaSelector;
  static readonly formulario = FormularioSelector;
}